<template>
  <router-view />
</template>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
@import 'assets/css/main';
@import 'assets/css/media';
@import 'assets/css/location';
@import 'assets/css/email';
@import 'assets/css/phone';
@import 'assets/css/card';
@import 'assets/css/form';
@import 'assets/css/border';
@import 'assets/css/button';
@import 'assets/css/printer';
</style>
